<template>
  <div class="tags-graph"> Test
    <!-- <div v-for="(queries, tag) in groupedQueries" :key="tag" class="graph-container">
      <h2 class="tag-title">{{ tag }}</h2>
      <div :ref="tag" class="graph"></div>
    </div> -->
  </div>
</template>

<!-- <script lang="ts">
import { defineComponent, onMounted, reactive } from 'vue';
import * as d3 from 'd3';

export default defineComponent({
  props: {
    queries: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup(props) {
    // Group queries by tags
    const groupedQueries = reactive(
      props.queries.reduce((acc, query) => {
        query.tags.forEach((tag) => {
          if (!acc[tag]) acc[tag] = [];
          acc[tag].push(query);
        });
        return acc;
      }, {})
    );

    const renderGraph = (tag: string, queries: any[]) => {
      const container = document.querySelector(`.graph[ref="${tag}"]`);
      if (!container) return;

      const width = 400;
      const height = 400;

      // Create SVG
      const svg = d3
        .select(container)
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      // Create nodes and links
      const nodes = queries.map((query, index) => ({
        id: `query-${index}`,
        title: query.title,
      }));

      const links = [];
      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          links.push({
            source: nodes[i].id,
            target: nodes[j].id,
          });
        }
      }

      // Simulation
      const simulation = d3
        .forceSimulation(nodes)
        .force(
          'link',
          d3
            .forceLink(links)
            .id((d) => d.id)
            .distance(100)
        )
        .force('charge', d3.forceManyBody().strength(-300))
        .force('center', d3.forceCenter(0, 0));

      // Draw links
      const link = svg
        .selectAll('line')
        .data(links)
        .enter()
        .append('line')
        .attr('stroke', '#aaa')
        .attr('stroke-width', 1);

      // Draw nodes
      const node = svg
        .selectAll('circle')
        .data(nodes)
        .enter()
        .append('circle')
        .attr('r', 8)
        .attr('fill', '#69b3a2');

      // Add labels
      const labels = svg
        .selectAll('text')
        .data(nodes)
        .enter()
        .append('text')
        .text((d) => d.title)
        .attr('font-size', '10px')
        .attr('dy', -15);

      // Update simulation
      simulation.on('tick', () => {
        link
          .attr('x1', (d) => d.source.x)
          .attr('y1', (d) => d.source.y)
          .attr('x2', (d) => d.target.x)
          .attr('y2', (d) => d.target.y);

        node.attr('cx', (d) => d.x).attr('cy', (d) => d.y);

        labels.attr('x', (d) => d.x).attr('y', (d) => d.y);
      });
    };

    onMounted(() => {
      // Render each graph by tag
      Object.entries(groupedQueries).forEach(([tag, queries]) => {
        renderGraph(tag, queries as any[]);
      });
    });

    return {
      groupedQueries,
    };
  },
});
</script>

<style>
.graph-container {
  margin-bottom: 2rem;
}
.tag-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 1rem;
}
.graph {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style> -->
